import { create } from "zustand";
import type { AccessPermission } from "@/types/access-grant";

interface DelegationState {
  onBehalfOfUserId: string | null;
  grantorName: string | null;
  permission: AccessPermission | null;
  setDelegation: (
    userId: string,
    name: string | null,
    permission: AccessPermission
  ) => void;
  clearDelegation: () => void;
}

const SESSION_KEY = "delegation";

function saveDelegation(state: {
  onBehalfOfUserId: string | null;
  grantorName: string | null;
  permission: AccessPermission | null;
}) {
  if (typeof window === "undefined") return;
  if (state.onBehalfOfUserId) {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
  } else {
    sessionStorage.removeItem(SESSION_KEY);
  }
}

function loadDelegation(): Partial<DelegationState> {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

const restored = loadDelegation();

export const useDelegationStore = create<DelegationState>((set) => ({
  onBehalfOfUserId: restored.onBehalfOfUserId ?? null,
  grantorName: restored.grantorName ?? null,
  permission: restored.permission ?? null,

  setDelegation: (userId, name, permission) => {
    set({ onBehalfOfUserId: userId, grantorName: name, permission });
    saveDelegation({ onBehalfOfUserId: userId, grantorName: name, permission });
  },

  clearDelegation: () => {
    set({ onBehalfOfUserId: null, grantorName: null, permission: null });
    saveDelegation({ onBehalfOfUserId: null, grantorName: null, permission: null });
  },
}));
